import { get } from '_core/config/api/Api';
import { IFinalResponse, InitApiType } from '_core/types';
import Definitions from '../Definitions';

const definitions = Definitions.GeoLocation;

const callGet = async (requestParams: {
  locationType: 'AUTOCOMPLETE' | 'DETAIL' | 'GEOLOCATION';
  input: string;
  language?: string;
}): Promise<IFinalResponse> => {
  const params: {
    type: string;
    langague?: string;
    input?: string;
    address?: string;
    placeId?: string;
  } = {
    type: requestParams.locationType.toLowerCase(),
  };

  if (requestParams.locationType === 'GEOLOCATION') {
    params.address = requestParams.input;
    delete params.input;
  } else if (requestParams.locationType === 'DETAIL') {
    params.placeId = requestParams.input;
    delete params.input;
  } else {
    params.input = requestParams.input;
  }

  const init: InitApiType = {
    params,
  };

  return get(
    definitions.API_DOMAIN,
    definitions.ENDPOINT_API_PATH,
    definitions.API_CREDENTIALS_TYPE,
    init,
  );
};

const call = { get: callGet };

export default { call, definitions };
